// extracted by mini-css-extract-plugin
export default {"select":"rNqI9MjOHocZ6bdxdHk6__select___"};